import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=c4e535d4"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__